export default "__VITE_ASSET__u0mYX4Wt__"